import {
  type MutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { z } from 'zod';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';

export type MrsLaunchDestination =
  | 'CLASSES'
  | 'CLASS_DETAILS'
  | 'USERS'
  | 'USER_DETAILS'
  | 'ADMIN_DETAILS'
  | 'STUDENT_DETAILS';

export interface CreateMrsLaunchUrlParams {
  destination: MrsLaunchDestination;
  classId?: string;
  studentId?: string;
  userId?: string;
  returnPath?: string;
  backLabel?: string;
}

const medLaunchUrlShape = z.object({
  signed_url: z.string(),
  expires_at: z.string(),
});
export type MrsLaunchUrl = z.infer<typeof medLaunchUrlShape>;

export async function createMrsLaunchUrlApi({
  destination,
  classId,
  studentId,
  userId,
  returnPath,
  backLabel,
}: CreateMrsLaunchUrlParams): Promise<MrsLaunchUrl> {
  return fetcher('/ednition/launch-url', {
    method: 'POST',
    service: '/rosteradapter',
    version: '/v2',
    body: JSON.stringify({
      destination,
      class_id: classId,
      student_id: studentId,
      user_id: userId,
      return_path: returnPath,
      back_label: backLabel,
    }),
  });
}

export function useCreateMrsLaunchUrlApi(
  customMutationOptions?: Omit<
    MutationOptions<MrsLaunchUrl, ApiError, CreateMrsLaunchUrlParams>,
    'mutationFn'
  >
): UseMutationResult<MrsLaunchUrl, ApiError, CreateMrsLaunchUrlParams> {
  return useMutation({
    mutationFn: createMrsLaunchUrlApi,
    ...customMutationOptions,
  });
}
